export default "__VITE_ASSET__DNeTJLcK__"